import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";
import { hsaSessionState } from "./types";

// Cursor advance. Called when the customer finishes every question in the
// current group. The server walks the flow from rootId, evaluates condition
// nodes against the answer set, and returns the next group (or completion).
//
// `currentGroupHandle` is a defensive guard: the client states what group
// it thinks it just finished, so the server can detect a stale advance
// (e.g. reload-then-advance after the walker has already moved past). For
// v1 the server just compares; mismatch responses are out of scope.
export const advanceHsaGroup = unaryRpc({
  name: "advanceHsaGroup",
  input: z.object({
    sessionToken: z.string().uuid(),
    currentGroupHandle: z.string().min(1),
  }),
  output: z.object({ state: hsaSessionState }),
});
